/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Photo_FailedInputs */

const en_directory_ai_tools_studio_photo_failed = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload failed. Try another photo.`)
};

const zh_directory_ai_tools_studio_photo_failed = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传失败，请换一张照片。`)
};

/**
* | output |
* | --- |
* | "Upload failed. Try another photo." |
*
* @param {Directory_Ai_Tools_Studio_Photo_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_photo_failed = /** @type {((inputs?: Directory_Ai_Tools_Studio_Photo_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Photo_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_photo_failed(inputs)
	return zh_directory_ai_tools_studio_photo_failed(inputs)
});
export { directory_ai_tools_studio_photo_failed as "directory.ai_tools.studio.photo_failed" }